import axiosClient from './axiosClient';

const SkillMatrixApi = {
  /**
   * Get list of skills with pagination/filters
   * @param {object} data - { page, limit, search, ... }
   * @returns {Promise<import('axios').AxiosResponse<{
   *  message: string,
   *  result: Array<{
   *    id: number,
   *    skill_name: string,
   *    activeStatus: boolean,
   *  }>,
   * }>} - List of skills
   */
  getList: (data = {}) => {
    return axiosClient.post('/api/skill/listSkill', data);
  },

  /**
   * Get skill by ID
   * @param {string|number} id
   */
  getById: (id) => {
    return axiosClient.post('/api/skill/viewById', { id });
  },

  /**
   * Create a new skill
   * @param {object} data - skill data
   */
  create: (data) => {
    return axiosClient.post('/api/skill/create', data);
  },

  /**
   * Update an existing skill
   * @param {object} data - skill data with id
   */
  update: (data) => {
    return axiosClient.post('/api/skill/update', data);
  },

  /**
   * Delete a skill
   * @param {string|number} id
   */
  delete: (id) => {
    return axiosClient.post('/api/skill/delete', { id });
  },

  /**
   * Toggle active status for one or more skills
   * @param {object} data - { ids: Array<number>, status: boolean }
   */
  updateStatus: (data) => {
    return axiosClient.post('/api/skill/skillStatus', data);
  },
};

export default SkillMatrixApi;
